<template>
  <div class="empty-data">
    <img src="@/shared/assets/images/empty.svg" alt="404" />
    <img
      src="@/shared/assets/images/bimi.empty.png"
      alt="bimi"
      class="empty-data__image-bimi"
    />
  </div>
</template>

<style lang="scss" scoped>
.empty-data {
  position: relative;
  width: 306px;
  height: 384px;
  &__image-bimi {
    position: absolute;
    left: 0;
    right: 0;
  }
}
</style>
